import type { TenantConfig } from '@/types/TenantConfig'

const gold = '#F5BA56'
const blue = '#253756'

export const stlholocaustmuseum: TenantConfig = {
  logo: 'assets/stlholocaustmuseum/static/logo-3.png',
  themeOptions: {
    primaryColor: gold,
    secondaryColor: gold,
    logoHeight: '62px',
    headerBackground: 'rgba(37, 55, 70, 0.8)',
    headerHeight: '90px',
    footerBackgroundColor: blue,
    footerTextColor: 'white',
    cartHeaderBackgroundColor: blue,
    memberLinksColor: 'white',
    memberLinksColorHover: 'white',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/stlholocaustmuseum/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-250px',
      },
    },
  },
}
